import { render, staticRenderFns } from "./TarifaFormulario.vue?vue&type=template&id=d2d021a8"
import script from "./TarifaFormulario.vue?vue&type=script&lang=js"
export * from "./TarifaFormulario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports